import { useEffect, useState } from "react";
import Layout from "../../layout.tsx/app";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import { Spinner } from "flowbite-react";
import Pagination from "../../../components/tables/pagination";
import Table from "../../../components/tables/base";
import { useOfflineAsesmenStore } from "../offline-asesmen.store";
import moment from "moment";
import { twMerge } from "tailwind-merge";
import { useNavigate } from "react-router-dom";
import { currency } from "../../../helper/currency";

const AsesmenRequest = () => {
  const [q, setQ] = useState<string | undefined>(undefined);
  const [page, setPage] = useState<number>(1);

  const navigate = useNavigate();

  const {
    offlineAssessments,
    getOfflineAssessments,
    loadingOfflineAssessments,
  } = useOfflineAsesmenStore();

  const handleSearch = async (input: string | undefined) => {
    await getOfflineAssessments({ page, q: input });
    setQ(input);
  };

  const handleNext = () => {
    if (page === offlineAssessments?.last_page) {
      return;
    }

    setPage(page + 1);
  };

  const handlePrevious = () => {
    if (page === 1) {
      return;
    }

    setPage(page - 1);
  };

  useEffect(() => {
    getOfflineAssessments({ page, q });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, getOfflineAssessments]);

  return (
    <>
      <Layout
        withPageTitle
        title="Permintaan Asesmen Tatap Muka"
        pageTitleContent={
          <div className="flex items-center">
            <input
              type="text"
              className="rounded-l-lg border-gray-300"
              placeholder={"Cari disini..."}
              onChange={(e) => setQ(e.target.value)}
              disabled={loadingOfflineAssessments}
              value={q}
            />
            {q && (
              <button
                onClick={() => handleSearch("")}
                className="py-3 px-2 border border-red-600 bg-red-600 text-white"
              >
                <X />
              </button>
            )}
            <button
              className={`${
                loadingOfflineAssessments ? "py-2 px-3" : "p-3"
              } text-lg rounded-r-lg ${
                loadingOfflineAssessments
                  ? "bg-blue-500 text-white cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700"
              }`}
              disabled={loadingOfflineAssessments}
              onClick={() => handleSearch(q ?? "")}
            >
              {loadingOfflineAssessments ? (
                <Spinner size={"sm"} />
              ) : (
                <MagnifyingGlass />
              )}
            </button>
          </div>
        }
      >
        <Table>
          <Table.Thead>
            <Table.Th>#</Table.Th>
            <Table.Th>Reg. ID</Table.Th>
            <Table.Th>Tanggal Tes</Table.Th>
            <Table.Th>Jenis Tes</Table.Th>
            <Table.Th>Client</Table.Th>
            <Table.Th>Perusahaan</Table.Th>
            <Table.Th className="text-center">Jml. Peserta</Table.Th>
            <Table.Th className="text-right">Total Harga</Table.Th>
            <Table.Th className="text-center">Status</Table.Th>
          </Table.Thead>
          <Table.Tbody>
            {loadingOfflineAssessments ? (
              <Table.TrLoading cols={8} rows={5} />
            ) : (
              <>
                {offlineAssessments?.data.length === 0 ? (
                  <Table.Tr>
                    <Table.Td cols={8} className="text-center py-3">
                      Tidak ada data ditemukan!
                    </Table.Td>
                  </Table.Tr>
                ) : (
                  <>
                    {offlineAssessments?.data.map((item, key) => (
                      <Table.Tr
                        key={key}
                        className="cursor-pointer hover:bg-blue-50"
                        onClick={() =>
                          navigate(`/offline-asesmen/request/${item.reg_id}`)
                        }
                      >
                        <Table.Td>
                          {(
                            key +
                            1 +
                            offlineAssessments.per_page *
                              (offlineAssessments.current_page - 1)
                          ).toString()}
                        </Table.Td>
                        <Table.Td>{item.reg_id}</Table.Td>
                        <Table.Td>
                          {item.test_date
                            ? moment(item.test_date).format("DD MMM YYYY")
                            : "-"}
                        </Table.Td>
                        <Table.Td>
                          <span
                            className={twMerge(
                              "text-sm px-2 rounded",
                              item.method === "offline"
                                ? "bg-purple-100 text-purple-600"
                                : "bg-pink-100 text-pink-600"
                            )}
                          >
                            {item.method}
                          </span>
                        </Table.Td>
                        <Table.Td>{item.client?.name}</Table.Td>
                        <Table.Td>{item.company?.name}</Table.Td>
                        <Table.Td className="text-center">
                          <>{item.number_participant}</>
                        </Table.Td>
                        <Table.Td className="text-right">
                          <>
                            {item.total_price
                              ? currency(item.total_price)
                              : null}
                          </>
                        </Table.Td>
                        <Table.Td className="text-center">
                          <span
                            className={`text-xs capitalize text-white py-1 px-3 rounded text-center ${
                              item.status === "draft" && "bg-gray-400"
                            } ${
                              item.status === "pending approval" &&
                              "bg-blue-600"
                            } ${item.status === "approved" && "bg-green-600"}`}
                          >
                            {item.status}
                          </span>
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </>
                )}
              </>
            )}
          </Table.Tbody>
        </Table>
        <Pagination
          currentPage={offlineAssessments?.current_page ?? 1}
          totalPage={offlineAssessments?.last_page ?? 1}
          onNext={handleNext}
          onPrevious={handlePrevious}
        />
      </Layout>
    </>
  );
};

export default AsesmenRequest;
